import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { ApplicationState } from "../../models/ApplicationState";
import { GetDateYYMMYYYYHHmm, State, currencyFormatter } from "../../Utils";
import { useEffect, useState } from "react";
import personajeAvionPose2 from "../../assets/images/personaje-avion-pose2.png";
import InterviewModal from "./InterviewModal";
import { changeInterviewDate, login } from "../../store/appStateReducer";
import CandidateInterviewUpdate from "../../models/CandidateInterviewUpdate";

import ResetPasswordScreen from "../ResetPasswordScreen";
import candidateService from "../../services/CandidateService";
import CandidateGuarantorStatus from "../../models/CandidateGuarantorStatus";
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LoadingModal from "../../components/LoadingModal";
import AuthService from "../../services/AuthService";

function DashboardScreen() {
  const appState: ApplicationState = useAppSelector((state) => state.appState);
  const [editInterview, setEditInterview] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isNew, setIsNew] = useState<boolean>(false);

  var dispatch = useAppDispatch();

  return (
    <Box>
      <Box textAlign="center" mb={3}>
        <Box
          sx={{
            mb: 1,
            textAlign: "center",
            padding: "0px !important",
          }}
        >
          <Box
            component="span"
            sx={{
              display: "inline-block",
              mr: 1,
              fontWeight: "bold",
              fontSize: 45,
            }}
          >
            ¡Bienvenido (a)
          </Box>
          <Box
            sx={{
              display: "inline-block",
              mr: 1,
              fontSize: 45,
              fontWeight: "bold",
              color: "#FE6B1B",
            }}
            component="span"
          >
            Ace Traveler!
          </Box>
        </Box>
        <Box
          component="p"
          sx={{
            display: "inline-block",
            my: 1,
            fontWeight: "bold",
            fontSize: 40,
          }}
        >
          {appState.fullName}
        </Box>
      </Box>

      {appState.mustChangePassword ? (
        <ResetPasswordScreen />
      ) : (
        <Grid container>
          <Grid sx={{ mb: 2 }} item xs={12}>
            {appState.candidateStatusMessage != "" ? (
              <Alert style={{ fontSize: 18 }} severity="warning">
                {appState.candidateStatusMessage}
              </Alert>
            ) : null}
          </Grid>
          <Grid item xs={12} lg={4} order={{ xs: 2, lg: 1 }}>
            <img
              style={{
                width: "100%",
                height: "100%",
                maxHeight: "500px",
                objectFit: "contain",
                transform: "scaleX(-1)",
              }}
              src={personajeAvionPose2}
            />
          </Grid>

          {appState.applicationStateId == 62 ||
          appState.applicationStateId == 25 ||
          appState.editForm ? (
            <Grid my="auto" item xs={12} lg={8} order={{ xs: 1, lg: 2 }}>
              <Box borderRadius={4} p={3} color="white" bgcolor="primary.main">
                <Typography textAlign="center" mb={2} variant="h5">
                  Detalles de tu entrevista
                </Typography>
                {appState.interviewStatus == null ||
                appState.interviewStatus == "" ? (
                  <Box mb={2} textAlign="center">
                    <Typography textAlign="center">
                      Estimado aplicante, por favor agregar una entrevista.
                    </Typography>
                    <Box>
                      <Grid item xs={12}>
                        <Button
                          onClick={() => {
                            setIsNew(true);
                            setEditInterview(true);
                          }}
                          color="secondary"
                          variant="contained"
                          sx={{ bgcolor: "secondary.main", mt: "10px" }}
                        >
                          Agregar Entrevista
                        </Button>
                      </Grid>
                    </Box>
                  </Box>
                ) : (
                  <Box>
                    {appState.applicationStateId == 62 ? (
                      <Box mb={2} display="flex">
                        <Typography>
                          Estimado aplicante, te indicamos que tu perfil está
                          pendiente de confirmación por parte de nuestro
                          personal. Una vez agotemos este proceso recibirás un
                          correo y una notificación con los siguientes paso a
                          seguir.
                        </Typography>
                      </Box>
                    ) : null}

                    <Box mb={2} display="flex">
                      <Typography mr={1} variant="body1">
                        Fecha/Hora:{" "}
                      </Typography>
                      <Typography>
                        {GetDateYYMMYYYYHHmm(new Date(appState.interviewDate!))}
                      </Typography>
                    </Box>
                    <Box mb={2} display="flex">
                      <Typography mr={1} variant="body1">
                        Lugar:
                      </Typography>
                      <Typography>{appState.interviewPlaceAddress}</Typography>
                    </Box>
                    <Box mb={1} display="flex">
                      <Typography mr={1} variant="body1">
                        Modalidad:
                      </Typography>
                      <Typography>{appState.interviewType}</Typography>
                    </Box>
                    <Box>
                      <Typography mr={1} variant="body1">
                        Atentamente
                      </Typography>
                      <Typography mr={1} variant="body1">
                        Equipo Ace International
                      </Typography>
                    </Box>
                    {appState.applicationStateId == 23 ||
                    appState.applicationStateId == 62 ? (
                      <Box>
                        <Grid item xs={12}>
                          <Button
                            onClick={() => {
                              setIsNew(false);
                              setEditInterview(true);
                            }}
                            color="secondary"
                            variant="contained"
                            sx={{ bgcolor: "secondary.main", mt: "10px" }}
                          >
                            Editar
                          </Button>
                        </Grid>
                      </Box>
                    ) : null}
                  </Box>
                )}

                <Dialog fullWidth={true} maxWidth="sm" open={editInterview}>
                  <DialogTitle>Editar Entrevista</DialogTitle>
                  <DialogContent>
                    <InterviewModal
                      isNew={isNew}
                      onSave={async (date, hour) => {
                        const interviewUpdate: CandidateInterviewUpdate = {
                          date: date,
                          hour: hour,
                        };

                        if (isNew) {
                          setIsLoading(true);
                          var applicationState: ApplicationState | null =
                            await AuthService.loadUserInfo();

                          dispatch(
                            login({ applicationState: applicationState! })
                          );
                          setIsLoading(false);
                        } else {
                          dispatch(changeInterviewDate(interviewUpdate));
                        }

                        setEditInterview(false);
                      }}
                      onClose={() => {
                        setEditInterview(false);
                      }}
                    />
                  </DialogContent>
                </Dialog>
              </Box>
            </Grid>
          ) : null}

          {!appState.editForm &&
          appState.applicationStateId > State.Declinado &&
          appState.applicationStateId != State.PendienteConfirmacion ? (
            <Grid
              rowSpacing={2}
              columnSpacing={2}
              item
              xs={12}
              lg={8}
              order={{ xs: 1, lg: 2 }}
            >
              <Grid columnSpacing={2} rowSpacing={2} container>
                <Grid item xs={12}>
                  <Typography variant="h5">Garantes</Typography>
                </Grid>
                <Grid item lg={6} xs={12}>
                  <Box
                    color="white"
                    borderRadius={2}
                    height={100}
                    sx={{ backgroundColor: "#26C6DB", display: "flex" }}
                  >
                    <Box
                      p={2}
                      display="flex"
                      alignItems="center"
                      width="100%"
                      justifyContent="space-between"
                    >
                      <PersonIcon sx={{ fontSize: "40px" }} />
                      <Box
                        textAlign="right"
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                      >
                        <Typography sx={{ fontSize: "19px" }}>
                          {appState.guarantorStatus != null &&
                            appState?.guarantorStatus.toUpperCase()}
                        </Typography>
                        <Typography sx={{ fontSize: "14px" }}>
                          Estatus De La Garantia
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item lg={6} xs={12}>
                  <Box
                    borderRadius={2}
                    height={100}
                    sx={{ backgroundColor: "#66bb6a", display: "flex" }}
                  >
                    <Box
                      color="white"
                      p={2}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      width="100%"
                    >
                      <CheckCircleIcon sx={{ fontSize: "40px" }} />
                      <Box
                        textAlign="right"
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                      >
                        <Typography sx={{ fontSize: "25px" }}>
                          {" "}
                          {appState?.guarantorPercentage != null &&
                            appState?.guarantorPercentage}
                          %
                        </Typography>
                        <Typography sx={{ fontSize: "14px" }}>
                          Porcentaje Aprobado
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h5">Balance</Typography>
                </Grid>
                <Grid item lg={6} xs={12}>
                  <Box
                    color="white"
                    borderRadius={2}
                    height={100}
                    sx={{ backgroundColor: "#e17055", display: "flex" }}
                  >
                    <Box
                      p={2}
                      display="flex"
                      alignItems="center"
                      width="100%"
                      justifyContent="space-between"
                    >
                      <MonetizationOnIcon sx={{ fontSize: "40px" }} />
                      <Box
                        textAlign="right"
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                      >
                        <Typography sx={{ fontSize: "25px" }}>
                          {appState.pendingAmountPesos != null &&
                            currencyFormatter.format(
                              appState?.pendingAmountPesos
                            )}
                        </Typography>
                        <Typography sx={{ fontSize: "14px" }}>
                          Total adeudado en pesos
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item lg={6} xs={12}>
                  <Box
                    borderRadius={2}
                    height={100}
                    sx={{ backgroundColor: "#74b9ff", display: "flex" }}
                  >
                    <Box
                      color="white"
                      p={2}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      width="100%"
                    >
                      <MonetizationOnIcon sx={{ fontSize: "40px" }} />
                      <Box
                        textAlign="right"
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                      >
                        <Typography sx={{ fontSize: "25px" }}>
                          {appState.pendingAmountDollar != null &&
                            currencyFormatter.format(
                              appState?.pendingAmountDollar
                            )}
                        </Typography>
                        <Typography sx={{ fontSize: "14px" }}>
                          Total adeudado en dólares
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          ) : null}

          {appState.applicationStateId == State.CompletedProgram ||
          appState.applicationStateId == State.CompletedProgramReturned ||
          appState.applicationStateId == State.Retire ||
          appState.applicationStateId == 0 ? (
            <Grid my="auto" item xs={12} lg={8} order={{ xs: 1, lg: 2 }}>
              <Grid container justifyContent="center">
                <Grid item lg={10} xs={12}>
                  <Box
                    borderRadius={4}
                    p={3}
                    color="white"
                    bgcolor="primary.main"
                  >
                    <Typography sx={{ mb: 2 }}>
                      Estimado aplicante, en este momento no posee una solicitud
                      activa en nuestros programas.
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                      Te invitamos a ir a la opción de solicitudes y hacer clic
                      en el botón re aplicar para que puedas nuevamente
                      participar en uno de nuestros programas y continuar siendo
                      parte de esta familia Ace internationa
                    </Typography>
                    <Typography>
                      Atentamente
                      <br /> Equipo Ace International
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      )}
      <LoadingModal isLoading={isLoading} loadingMessage="Actualizando" />
    </Box>
  );
}
export default DashboardScreen;
